// Local SEO landing pages — one per North Carolina market we serve.
export const LOCATIONS = [
  {
    slug: "greensboro-nc",
    city: "Greensboro",
    metro: "Piedmont Triad",
    headline: "Business loans in Greensboro, NC — from a lender that calls the Triad home.",
    intro: [
      "Encore Commercial Capital is headquartered right here in Greensboro, and we've built our reputation funding the businesses that keep the Piedmont Triad moving — manufacturers along the I-40/I-85 corridor, logistics and distribution operations near PTI Airport, contractors, restaurants, and family-owned companies across Guilford County.",
      "Whether you need working capital to cover a seasonal gap, equipment financing for a new production line, or an SBA loan to acquire commercial space on Wendover or downtown, our local team can usually deliver a decision in as soon as 2 hours — and because we're your neighbors, you can actually talk to us.",
    ],
    industries: ["Manufacturing", "Logistics & distribution", "Aviation services", "Construction & trades", "Restaurants & hospitality", "Professional services"],
  },
  {
    slug: "charlotte-nc",
    city: "Charlotte",
    metro: "Charlotte metro",
    headline: "Fast, flexible business financing in Charlotte, NC.",
    intro: [
      "Charlotte may be the second-largest banking hub in the country, but big banks still say no to thousands of healthy Queen City businesses every year. Encore Commercial Capital fills that gap with alternative financing built for real-world businesses — from Uptown professional firms and South End startups to contractors, medical practices, and hospitality groups across Mecklenburg County.",
      "We offer working capital, merchant cash advances, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — with approvals in as soon as 2 hours and closings typically inside 7–10 days, so you can move at the speed Charlotte grows.",
    ],
    industries: ["Professional & financial services", "Construction & development", "Healthcare practices", "Hospitality & restaurants", "Transportation", "Fitness & retail"],
  },
  {
    slug: "winston-salem-nc",
    city: "Winston-Salem",
    metro: "Piedmont Triad",
    headline: "Business loans in Winston-Salem, NC that keep you growing.",
    intro: [
      "From the labs and startups of the Innovation Quarter to the manufacturers, medical practices, and food-and-beverage companies that anchor Forsyth County, Winston-Salem businesses need capital partners that move quickly. Encore Commercial Capital — based just down I-40 in Greensboro — funds Twin City businesses with financing the big banks are too slow to deliver.",
      "Credit scores from 500+ are considered, paperwork is minimal, and our team walks you through every option — working capital, equipment financing, SBA loans, lines of credit, and commercial real estate — so you choose the structure that actually fits your cash flow.",
    ],
    industries: ["Healthcare & biotech", "Advanced manufacturing", "Food & beverage", "Construction & trades", "Retail & services", "Transportation"],
  },
  {
    slug: "raleigh-nc",
    city: "Raleigh",
    metro: "Research Triangle",
    headline: "Business financing in Raleigh, NC at Triangle speed.",
    intro: [
      "Raleigh is one of the fastest-growing business markets in America, and waiting weeks on a bank decision can cost you the opportunity. Encore Commercial Capital funds businesses across the City of Oaks and greater Wake County — tech and professional firms downtown, contractors building the boom, medical and dental practices, restaurants, and the service companies that support them all.",
      "Apply online in about five minutes or talk to a specialist by phone. Approvals come in as soon as 2 hours, closings usually within 7–10 days, and programs range from short-term working capital to SBA and commercial real estate loans.",
    ],
    industries: ["Technology & SaaS", "Construction & development", "Medical & dental practices", "Professional services", "Restaurants & retail", "Landscaping & trades"],
  },
  {
    slug: "cary-nc",
    city: "Cary",
    metro: "Research Triangle",
    headline: "Business loans in Cary, NC for companies on the move.",
    intro: [
      "Cary sits at the heart of the Triangle's growth — a hub for technology employers, healthcare practices, retail centers, and the professional service firms that serve one of the most educated workforces in the Southeast. When Cary businesses need capital to expand, hire, or bridge a receivables gap, Encore Commercial Capital delivers financing on your timeline.",
      "We consider the health of your whole business — revenue, time in business, and trajectory — not just a credit score. That means practical approvals for working capital, equipment, lines of credit, SBA loans, and commercial property, often within hours of your application.",
    ],
    industries: ["Technology & software", "Healthcare & wellness", "Professional services", "Retail & franchises", "Restaurants", "Home services"],
  },
  {
    slug: "durham-nc",
    city: "Durham",
    metro: "Research Triangle",
    headline: "Flexible business funding in Durham, NC.",
    intro: [
      "From Research Triangle Park biotech suppliers to the startups of American Underground and the restaurants and retailers that make the Bull City what it is, Durham businesses grow fast — and their capital needs don't wait on bank committees. Encore Commercial Capital provides alternative financing designed for that pace.",
      "Working capital loans, merchant cash advances, equipment financing, business lines of credit, SBA programs, and commercial real estate loans — all with minimal paperwork, decisions in as soon as 2 hours, and a specialist who guides you from application to funding.",
    ],
    industries: ["Biotech & life sciences", "Startups & technology", "Restaurants & food halls", "Healthcare practices", "Construction & trades", "Creative & professional services"],
  },
  {
    slug: "rocky-mount-nc",
    city: "Rocky Mount",
    metro: "Eastern North Carolina",
    headline: "Business loans in Rocky Mount, NC that work as hard as you do.",
    intro: [
      "Rocky Mount's economy is built on making and moving things — manufacturing plants, food processing, warehousing and logistics along US-64 and I-95, and the farms and trucking companies that connect them. Encore Commercial Capital funds the working businesses of Nash and Edgecombe counties when banks tighten up.",
      "Need equipment for the floor, working capital to cover payroll through a slow season, or financing for a commercial building? Credit scores from 500+ are considered, and our streamlined process delivers decisions in as soon as 2 hours.",
    ],
    industries: ["Manufacturing", "Food processing", "Trucking & logistics", "Agriculture", "Warehousing & distribution", "Auto & equipment services"],
  },
  {
    slug: "wilson-nc",
    city: "Wilson",
    metro: "Eastern North Carolina",
    headline: "Business financing in Wilson, NC — practical capital, fast.",
    intro: [
      "Wilson has always known how to work — from its agricultural roots to today's pharmaceutical manufacturing, distribution, and a growing small-business community powered by one of the best broadband networks in the state. Encore Commercial Capital brings Wilson County businesses the same fast, flexible financing we deliver across North Carolina.",
      "Apply online in about five minutes or call a specialist. We'll match you to the right program — working capital, equipment financing, a line of credit, an SBA loan, or commercial real estate — with approvals in as soon as 2 hours and funding typically within days.",
    ],
    industries: ["Pharmaceutical & manufacturing", "Agriculture & agribusiness", "Distribution & logistics", "Contractors & trades", "Retail & restaurants", "Business services"],
  },
  {
    slug: "elizabeth-city-nc",
    city: "Elizabeth City",
    metro: "Albemarle region",
    headline: "Business loans in Elizabeth City, NC — capital for the Harbor of Hospitality.",
    intro: [
      "Elizabeth City anchors the Albemarle region's economy — aviation and maintenance work around the Coast Guard's largest air station, marine services along the Pasquotank River, farms and agribusiness across the county, and the shops, restaurants, and service companies that keep downtown moving. Encore Commercial Capital brings the same fast, flexible financing we deliver across North Carolina to businesses here.",
      "Whether you need working capital to smooth a seasonal cycle, equipment financing for the shop or the field, a line of credit, an SBA loan, or commercial real estate financing, apply online in about five minutes or call a specialist — approvals come in as soon as 2 hours.",
    ],
    industries: ["Aviation & aerospace services", "Marine & boatyard services", "Agriculture & agribusiness", "Healthcare & services", "Restaurants & retail", "Contractors & trades"],
  },
];

// State-level SEO pages — markets served beyond North Carolina.
export const STATES = [
  {
    slug: "south-carolina",
    name: "South Carolina",
    headline: "Business loans in South Carolina — fast capital for the Palmetto State.",
    intro: [
      "From the port logistics and hospitality operators of Charleston to the manufacturers of the Greenville–Spartanburg corridor, Columbia's contractors and service firms, and the tourism businesses along the Grand Strand, South Carolina companies grow fast — and their financing shouldn't slow them down. Encore Commercial Capital funds businesses across the Palmetto State with the same speed we deliver at home in the Carolinas.",
      "Working capital, merchant cash advances, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — approvals in as soon as 2 hours, closings typically inside 7–10 days, and credit scores from 500+ considered.",
    ],
    industries: ["Manufacturing", "Port & logistics", "Hospitality & tourism", "Construction & trades", "Restaurants & retail", "Professional services"],
  },
  {
    slug: "virginia",
    name: "Virginia",
    headline: "Business financing in Virginia, from Richmond to Hampton Roads.",
    intro: [
      "Virginia's economy runs on variety — government and defense contractors around Hampton Roads and Northern Virginia, Richmond's professional and financial firms, shipping and ship-repair along the ports of Norfolk and Newport News, and the farms, trucking companies, and main-street businesses that connect it all. Encore Commercial Capital brings flexible, fast financing to businesses across the Commonwealth.",
      "Apply online in about five minutes or talk to a specialist by phone. We'll match you to the right program — working capital, equipment financing, a line of credit, an SBA loan, or commercial real estate — with decisions in as soon as 2 hours.",
    ],
    industries: ["Government & defense contractors", "Maritime & ship repair", "Professional services", "Trucking & logistics", "Construction & trades", "Restaurants & retail"],
  },
  {
    slug: "georgia",
    name: "Georgia",
    headline: "Business loans in Georgia — capital that moves at Atlanta speed.",
    intro: [
      "Georgia is one of the busiest business corridors in the Southeast — metro Atlanta's logistics, film, tech, and service economies, the Port of Savannah's freight and warehousing boom, and the manufacturers and agribusinesses that anchor Augusta, Macon, and beyond. Encore Commercial Capital funds Georgia businesses that can't afford to wait weeks on a bank committee.",
      "Whether you need working capital to bridge receivables, equipment for the warehouse floor, or SBA and commercial real estate financing to expand, our streamlined process delivers approvals in as soon as 2 hours with minimal paperwork.",
    ],
    industries: ["Logistics & warehousing", "Transportation & trucking", "Construction & development", "Hospitality & restaurants", "Healthcare practices", "Agribusiness"],
  },
  {
    slug: "florida",
    name: "Florida",
    headline: "Fast, flexible business funding across Florida.",
    intro: [
      "Florida businesses live with seasonality — the tourism and hospitality surges of Orlando and the coasts, Miami's international trade cycles, Tampa's construction boom, and Jacksonville's logistics corridors. Encore Commercial Capital structures financing around real Florida cash flow, not a banker's calendar.",
      "Merchant cash advances and working capital for seasonal swings, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — with approvals in as soon as 2 hours and specialists who guide you from application to funding.",
    ],
    industries: ["Hospitality & tourism", "Restaurants & food service", "Construction & trades", "International trade & logistics", "Healthcare & med-spas", "Marine & charter services"],
  },
  {
    slug: "ohio",
    name: "Ohio",
    headline: "Business loans in Ohio — practical capital for hardworking companies.",
    intro: [
      "Ohio makes and moves things — manufacturing across Cleveland, Cincinnati, and Dayton, the distribution hubs around Columbus, trucking fleets on the I-70/I-75 corridors, and the healthcare systems and main-street businesses in between. Encore Commercial Capital funds Ohio companies when banks tighten up or simply take too long.",
      "Equipment financing for the floor or the fleet, working capital to cover payroll through a slow stretch, lines of credit, SBA loans, and commercial real estate — credit scores from 500+ considered and decisions in as soon as 2 hours.",
    ],
    industries: ["Manufacturing", "Trucking & distribution", "Healthcare practices", "Construction & trades", "Restaurants & retail", "Business services"],
  },
  {
    slug: "north-carolina",
    name: "North Carolina",
    headline: "Business loans in North Carolina — from a lender that calls the Tar Heel State home.",
    intro: [
      "Encore Commercial Capital is headquartered in Greensboro, and North Carolina is where we do our deepest work — the manufacturers and logistics operators of the Piedmont Triad, Charlotte's financial and construction economies, the Research Triangle's technology and healthcare firms, and the agriculture, trucking, and main-street businesses that power the east and the mountains alike.",
      "Because we're local, you get more than fast capital — working capital, merchant cash advances, equipment financing, business lines of credit, SBA loans, HELOCs for business purposes, and commercial real estate financing — you get a team you can actually reach, with approvals in as soon as 2 hours and credit scores from 500+ considered.",
    ],
    industries: ["Manufacturing", "Logistics & distribution", "Technology & life sciences", "Construction & trades", "Agriculture & agribusiness", "Restaurants & hospitality"],
  },
  {
    slug: "maryland",
    name: "Maryland",
    headline: "Business financing in Maryland — from the Port of Baltimore to the Beltway.",
    intro: [
      "Maryland businesses operate in one of the densest economic corridors in America — federal contractors and cybersecurity firms along the Baltimore–Washington corridor, Port of Baltimore logistics and warehousing, Annapolis and Eastern Shore hospitality and marine trades, and the healthcare practices and biotech suppliers clustered around Johns Hopkins and the NIH. Encore Commercial Capital funds Old Line State businesses that can't wait weeks on a bank committee.",
      "Working capital, merchant cash advances, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — approvals in as soon as 2 hours, closings typically inside 7–10 days, and credit scores from 500+ considered.",
    ],
    industries: ["Government & defense contractors", "Cybersecurity & technology", "Port logistics & warehousing", "Healthcare & biotech", "Construction & trades", "Hospitality & marine services"],
  },
  {
    slug: "new-york",
    name: "New York",
    headline: "Business loans in New York — capital that keeps pace with the Empire State.",
    intro: [
      "From the restaurants, contractors, and professional firms of the five boroughs to Long Island's medical practices and distributors, the logistics corridors of the Hudson Valley, and the manufacturers of Buffalo, Rochester, and Syracuse — New York businesses move fast and need capital partners that move faster. Encore Commercial Capital delivers alternative financing when traditional banks slow you down.",
      "Merchant cash advances and working capital built for New York cash flow, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — apply online in about five minutes with approvals in as soon as 2 hours.",
    ],
    industries: ["Restaurants & food service", "Construction & development", "Professional services", "Healthcare practices", "Transportation & logistics", "Retail & e-commerce"],
  },
  {
    slug: "texas",
    name: "Texas",
    headline: "Business financing in Texas — big capital for the biggest small-business economy.",
    intro: [
      "Everything is bigger in Texas, including the funding gap when banks say no. Encore Commercial Capital funds businesses across the Lone Star State — Houston's energy services and medical center economies, the DFW metroplex's logistics and construction booms, San Antonio's trades and hospitality operators, and Austin's technology and service firms — plus the trucking companies and agribusinesses that connect them all.",
      "Working capital, merchant cash advances, equipment financing for the yard or the fleet, business lines of credit, SBA loans, and commercial real estate financing — decisions in as soon as 2 hours, minimal paperwork, and credit scores from 500+ considered.",
    ],
    industries: ["Energy & oilfield services", "Trucking & logistics", "Construction & development", "Healthcare practices", "Restaurants & hospitality", "Technology & business services"],
  },
];

// Out-of-state metro SEO pages — key cities in the states we serve.
export const METROS = [
  {
    slug: "charleston-sc",
    city: "Charleston",
    state: "SC",
    stateName: "South Carolina",
    metro: "Lowcountry",
    headline: "Business loans in Charleston, SC — capital that keeps pace with the port.",
    intro: [
      "Charleston runs on movement — container traffic through one of the busiest ports on the East Coast, a hospitality economy that welcomes millions of visitors a year, and the manufacturers and logistics operators spreading up the I-26 corridor toward Summerville. Encore Commercial Capital funds Lowcountry businesses that can't wait weeks for a bank committee to meet.",
      "Working capital for seasonal hospitality swings, equipment financing for the warehouse or the kitchen, lines of credit, SBA loans, and commercial real estate financing — approvals in as soon as 2 hours and credit scores from 500+ considered.",
    ],
    industries: ["Port & logistics", "Hospitality & tourism", "Restaurants & food service", "Aerospace & manufacturing", "Construction & trades", "Marine services"],
  },
  {
    slug: "greenville-sc",
    city: "Greenville",
    state: "SC",
    stateName: "South Carolina",
    metro: "Upstate",
    headline: "Business financing in Greenville, SC for the hardest-working corridor in the Upstate.",
    intro: [
      "The Greenville–Spartanburg corridor is one of the strongest manufacturing economies in the Southeast — automotive suppliers along I-85, advanced materials plants, and the trucking and distribution companies that move it all, plus a booming downtown of restaurants and professional firms. Encore Commercial Capital brings Upstate businesses fast, flexible capital when the banks slow down.",
      "Equipment financing for the floor or the fleet, working capital to bridge receivables, business lines of credit, SBA loans, and commercial real estate financing — decisions in as soon as 2 hours with minimal paperwork.",
    ],
    industries: ["Automotive & advanced manufacturing", "Trucking & distribution", "Construction & trades", "Restaurants & hospitality", "Professional services", "Healthcare practices"],
  },
  {
    slug: "columbia-sc",
    city: "Columbia",
    state: "SC",
    stateName: "South Carolina",
    metro: "Midlands",
    headline: "Business loans in Columbia, SC — steady capital for the Midlands.",
    intro: [
      "As South Carolina's capital and the heart of the Midlands, Columbia blends government and university economies with the contractors, logistics operators, healthcare practices, and main-street businesses that serve them. Encore Commercial Capital funds Columbia-area businesses with alternative financing built for real-world cash flow.",
      "Whether you need working capital through a slow season, equipment for the shop, a line of credit, an SBA loan, or commercial real estate financing, apply online in about five minutes — approvals in as soon as 2 hours.",
    ],
    industries: ["Government services & contractors", "Healthcare practices", "Logistics & distribution", "Construction & trades", "Restaurants & retail", "Professional services"],
  },
  {
    slug: "richmond-va",
    city: "Richmond",
    state: "VA",
    stateName: "Virginia",
    metro: "Central Virginia",
    headline: "Business financing in Richmond, VA — fast capital for the River City.",
    intro: [
      "Richmond's economy spans Fortune 500 headquarters, a deep bench of professional and financial firms, a nationally known food scene, and the manufacturers and logistics companies along the I-95 corridor. When Richmond businesses need to move — on a contract, a building, or a busy season — Encore Commercial Capital delivers financing at that speed.",
      "Working capital, merchant cash advances, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — approvals in as soon as 2 hours, closings typically inside 7–10 days.",
    ],
    industries: ["Professional & financial services", "Restaurants & breweries", "Manufacturing", "Logistics & distribution", "Construction & trades", "Healthcare practices"],
  },
  {
    slug: "virginia-beach-va",
    city: "Virginia Beach",
    state: "VA",
    stateName: "Virginia",
    metro: "Hampton Roads",
    headline: "Business loans in Virginia Beach, VA — built for Hampton Roads.",
    intro: [
      "Hampton Roads businesses work around tides, tourists, and the largest naval presence in the world — defense contractors and ship-repair outfits, oceanfront hospitality that surges every summer, and the trades and services that keep seven cities running. Encore Commercial Capital structures financing around that rhythm, not a banker's calendar.",
      "Seasonal working capital, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — credit scores from 500+ considered and decisions in as soon as 2 hours.",
    ],
    industries: ["Defense & government contractors", "Hospitality & tourism", "Maritime & ship repair", "Construction & trades", "Restaurants & retail", "Healthcare practices"],
  },
  {
    slug: "atlanta-ga",
    city: "Atlanta",
    state: "GA",
    stateName: "Georgia",
    metro: "Metro Atlanta",
    headline: "Business loans in Atlanta, GA — capital that moves at metro speed.",
    intro: [
      "Metro Atlanta is the commercial engine of the Southeast — logistics and warehousing around the airport and the Perimeter, film and media production, a booming construction market, and tens of thousands of restaurants, practices, and service firms across its counties. Encore Commercial Capital funds Atlanta businesses that can't afford to wait on traditional underwriting.",
      "Working capital, merchant cash advances, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — apply online in about five minutes with approvals in as soon as 2 hours.",
    ],
    industries: ["Logistics & warehousing", "Film & media services", "Construction & development", "Restaurants & hospitality", "Healthcare practices", "Professional services"],
  },
  {
    slug: "savannah-ga",
    city: "Savannah",
    state: "GA",
    stateName: "Georgia",
    metro: "Coastal Georgia",
    headline: "Business financing in Savannah, GA — from the port to the squares.",
    intro: [
      "Savannah's economy is surging — record container volumes through the Port of Savannah, warehouse and distribution growth along I-16 and I-95, manufacturing expansion across the region, and a historic district full of hospitality businesses that run hard year-round. Encore Commercial Capital brings Coastal Georgia businesses capital that keeps up.",
      "Equipment financing for the yard or the fleet, working capital for seasonal swings, business lines of credit, SBA loans, and commercial real estate financing — decisions in as soon as 2 hours with minimal paperwork.",
    ],
    industries: ["Port & logistics", "Warehousing & distribution", "Manufacturing", "Hospitality & tourism", "Construction & trades", "Restaurants & retail"],
  },
  {
    slug: "miami-fl",
    city: "Miami",
    state: "FL",
    stateName: "Florida",
    metro: "South Florida",
    headline: "Business loans in Miami, FL — capital for the gateway of the Americas.",
    intro: [
      "Miami moves fast — international trade through the port and airport, a hospitality and restaurant economy with global reach, booming construction from Brickell to Doral, and thousands of import/export, logistics, and professional firms in between. Encore Commercial Capital funds South Florida businesses on Miami time, not bank time.",
      "Merchant cash advances and working capital built for trade and seasonality, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — approvals in as soon as 2 hours.",
    ],
    industries: ["International trade & logistics", "Hospitality & restaurants", "Construction & development", "Healthcare & med-spas", "Professional services", "Retail & e-commerce"],
  },
  {
    slug: "orlando-fl",
    city: "Orlando",
    state: "FL",
    stateName: "Florida",
    metro: "Central Florida",
    headline: "Business financing in Orlando, FL that works around the seasons.",
    intro: [
      "Orlando hosts more visitors than almost any city on earth, and Central Florida businesses feel every peak and valley — hospitality and attractions suppliers, restaurants and event companies, the contractors building the region's growth, and the healthcare and service firms supporting one of the fastest-growing metros in the country. Encore Commercial Capital structures funding around that cash flow.",
      "Seasonal working capital, merchant cash advances, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — credit scores from 500+ considered.",
    ],
    industries: ["Hospitality & attractions", "Restaurants & catering", "Construction & trades", "Healthcare practices", "Transportation & logistics", "Events & entertainment services"],
  },
  {
    slug: "tampa-fl",
    city: "Tampa",
    state: "FL",
    stateName: "Florida",
    metro: "Tampa Bay",
    headline: "Business loans in Tampa, FL — fuel for the Bay area boom.",
    intro: [
      "Tampa Bay is one of the fastest-growing business markets in America — cranes over downtown and the Westshore district, a thriving port, financial and professional firms relocating in waves, and the contractors, restaurants, and healthcare practices growing with them. Encore Commercial Capital funds Tampa businesses that need capital before the opportunity passes.",
      "Working capital, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — apply online in about five minutes, approvals in as soon as 2 hours.",
    ],
    industries: ["Construction & development", "Professional & financial services", "Healthcare practices", "Port & logistics", "Restaurants & hospitality", "Marine services"],
  },
  {
    slug: "jacksonville-fl",
    city: "Jacksonville",
    state: "FL",
    stateName: "Florida",
    metro: "Northeast Florida",
    headline: "Business financing in Jacksonville, FL — logistics-grade capital.",
    intro: [
      "Jacksonville is a logistics powerhouse — JAXPORT container and auto volumes, three major rail lines, massive distribution campuses along I-95 and I-10, and the trucking companies that tie it together, plus strong financial services, healthcare, and construction economies. Encore Commercial Capital keeps Northeast Florida businesses funded and moving.",
      "Equipment financing for the fleet or the warehouse floor, working capital, business lines of credit, SBA loans, and commercial real estate financing — decisions in as soon as 2 hours.",
    ],
    industries: ["Logistics & distribution", "Trucking & transportation", "Financial services", "Construction & trades", "Healthcare practices", "Restaurants & retail"],
  },
  {
    slug: "columbus-oh",
    city: "Columbus",
    state: "OH",
    stateName: "Ohio",
    metro: "Central Ohio",
    headline: "Business loans in Columbus, OH — capital for the Midwest's growth engine.",
    intro: [
      "Columbus is booming — massive distribution and data-center campuses ringing the outerbelt, a deep logistics corridor at Rickenbacker, one of the country's strongest retail and food-service test markets, and the contractors and professional firms building it all. Encore Commercial Capital funds Central Ohio businesses at the speed the region grows.",
      "Working capital, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — approvals in as soon as 2 hours and credit scores from 500+ considered.",
    ],
    industries: ["Logistics & distribution", "Construction & development", "Restaurants & retail", "Healthcare practices", "Professional services", "Technology & data services"],
  },
  {
    slug: "cleveland-oh",
    city: "Cleveland",
    state: "OH",
    stateName: "Ohio",
    metro: "Northeast Ohio",
    headline: "Business financing in Cleveland, OH — practical capital for companies that make things.",
    intro: [
      "Northeast Ohio makes things — precision manufacturers and metal shops, the healthcare economy anchored by world-class hospital systems, Great Lakes shipping and logistics, and the trades and trucking companies that keep it all moving. Encore Commercial Capital funds Cleveland businesses when banks tighten up or take too long.",
      "Equipment financing for the floor, working capital through a slow stretch, lines of credit, SBA loans, and commercial real estate — decisions in as soon as 2 hours with minimal paperwork.",
    ],
    industries: ["Manufacturing & metals", "Healthcare & medical suppliers", "Trucking & logistics", "Construction & trades", "Restaurants & retail", "Business services"],
  },
  {
    slug: "cincinnati-oh",
    city: "Cincinnati",
    state: "OH",
    stateName: "Ohio",
    metro: "Greater Cincinnati",
    headline: "Business loans in Cincinnati, OH — Queen City capital, delivered fast.",
    intro: [
      "Greater Cincinnati blends corporate headquarters with a dense ecosystem of suppliers, logistics operators around the CVG air hub, manufacturers along the I-75 corridor, and the restaurants, practices, and service firms spread across Ohio, Kentucky, and Indiana. Encore Commercial Capital funds Queen City businesses that need answers in hours, not weeks.",
      "Working capital, merchant cash advances, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — approvals in as soon as 2 hours.",
    ],
    industries: ["Manufacturing & suppliers", "Air cargo & logistics", "Construction & trades", "Restaurants & hospitality", "Healthcare practices", "Professional services"],
  },
  {
    slug: "baltimore-md",
    city: "Baltimore",
    state: "MD",
    stateName: "Maryland",
    metro: "Greater Baltimore",
    headline: "Business financing in Baltimore, MD — from the port to the Beltway.",
    intro: [
      "Baltimore works at the water and beyond — Port of Baltimore cargo and the warehousing that follows it, a world-class medical economy around Johns Hopkins and the University of Maryland systems, federal contractors along the corridor to Washington, and the contractors, restaurants, and service firms in every neighborhood. Encore Commercial Capital funds Charm City businesses without the bank runaround.",
      "Working capital, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — decisions in as soon as 2 hours and credit scores from 500+ considered.",
    ],
    industries: ["Port logistics & warehousing", "Healthcare & biotech", "Government contractors", "Construction & trades", "Restaurants & retail", "Professional services"],
  },
  {
    slug: "rockville-md",
    city: "Rockville",
    state: "MD",
    stateName: "Maryland",
    metro: "DC Metro · Montgomery County",
    headline: "Business loans in Rockville, MD — capital for the I-270 corridor.",
    intro: [
      "Montgomery County's I-270 corridor is one of the densest biotech and federal-services economies in the country — life-science firms and labs, government contractors and consultants, medical and dental practices, and the restaurants and retailers serving one of America's most affluent counties. Encore Commercial Capital funds DC-metro Maryland businesses with speed the big banks can't match.",
      "Working capital, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — apply online in about five minutes, approvals in as soon as 2 hours.",
    ],
    industries: ["Biotech & life sciences", "Government contractors & consulting", "Medical & dental practices", "Professional services", "Restaurants & retail", "Construction & trades"],
  },
  {
    slug: "new-york-city-ny",
    city: "New York City",
    state: "NY",
    stateName: "New York",
    metro: "Five Boroughs",
    headline: "Business loans in New York City — capital at the speed of the five boroughs.",
    intro: [
      "No market moves faster or costs more to stand still in than New York City. From Manhattan professional firms and Brooklyn food businesses to Queens contractors, Bronx distributors, and Staten Island trades, NYC businesses need capital partners that answer today. Encore Commercial Capital delivers alternative financing when the banks say 'come back with two more years of statements.'",
      "Merchant cash advances and working capital built for NYC cash flow, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — approvals in as soon as 2 hours.",
    ],
    industries: ["Restaurants & food service", "Construction & development", "Professional services", "Retail & e-commerce", "Healthcare practices", "Transportation & logistics"],
  },
  {
    slug: "buffalo-ny",
    city: "Buffalo",
    state: "NY",
    stateName: "New York",
    metro: "Western New York",
    headline: "Business financing in Buffalo, NY — steady capital for the Nickel City comeback.",
    intro: [
      "Buffalo's resurgence is real — advanced manufacturing and food production, a growing medical campus, cross-border trade with Canada, and the contractors and small businesses rebuilding neighborhoods across Western New York. Encore Commercial Capital funds Buffalo businesses with practical financing that fits how the region actually works.",
      "Equipment financing, working capital through the winter months, business lines of credit, SBA loans, and commercial real estate financing — credit scores from 500+ considered and decisions in as soon as 2 hours.",
    ],
    industries: ["Manufacturing & food production", "Healthcare & medical campus", "Cross-border trade & logistics", "Construction & trades", "Restaurants & retail", "Business services"],
  },
  {
    slug: "houston-tx",
    city: "Houston",
    state: "TX",
    stateName: "Texas",
    metro: "Greater Houston",
    headline: "Business loans in Houston, TX — energy-grade capital for every industry.",
    intro: [
      "Houston is the most entrepreneurial big city in America — energy services and oilfield suppliers, the world's largest medical center, Port Houston's petrochemical and container complex, and hundreds of thousands of contractors, restaurants, and service firms across a metro bigger than some states. Encore Commercial Capital funds Houston businesses at Houston scale.",
      "Working capital, merchant cash advances, equipment financing for the yard or the fleet, business lines of credit, SBA loans, and commercial real estate financing — decisions in as soon as 2 hours.",
    ],
    industries: ["Energy & oilfield services", "Medical & healthcare", "Port & petrochemical logistics", "Construction & trades", "Restaurants & hospitality", "Trucking & distribution"],
  },
  {
    slug: "dallas-tx",
    city: "Dallas",
    state: "TX",
    stateName: "Texas",
    metro: "DFW Metroplex",
    headline: "Business financing in Dallas, TX — capital that keeps up with the Metroplex.",
    intro: [
      "The DFW Metroplex adds more people and businesses than almost anywhere in the country — corporate relocations, massive logistics and distribution hubs, a construction market running at full tilt, and the professional firms, restaurants, and practices that grow alongside. Encore Commercial Capital funds Dallas–Fort Worth businesses that can't wait weeks on a decision.",
      "Working capital, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — apply online in about five minutes with approvals in as soon as 2 hours.",
    ],
    industries: ["Logistics & distribution", "Construction & development", "Professional & financial services", "Restaurants & hospitality", "Healthcare practices", "Technology & business services"],
  },
  {
    slug: "san-antonio-tx",
    city: "San Antonio",
    state: "TX",
    stateName: "Texas",
    metro: "South Texas",
    headline: "Business loans in San Antonio, TX — steady capital for Military City USA.",
    intro: [
      "San Antonio blends military and cybersecurity economies with a tourism engine on the River Walk, a fast-growing manufacturing base, and the contractors, restaurants, and family businesses that give the city its character. Encore Commercial Capital funds San Antonio businesses with financing built for real-world cash flow.",
      "Working capital, merchant cash advances, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — credit scores from 500+ considered and decisions in as soon as 2 hours.",
    ],
    industries: ["Military & cybersecurity contractors", "Hospitality & tourism", "Manufacturing", "Construction & trades", "Restaurants & retail", "Healthcare practices"],
  },
  {
    slug: "austin-tx",
    city: "Austin",
    state: "TX",
    stateName: "Texas",
    metro: "Central Texas",
    headline: "Business financing in Austin, TX at startup speed.",
    intro: [
      "Austin grew from college town to tech capital in a generation, and Central Texas businesses feel the pace — technology firms and the services around them, a legendary food and music economy, and a construction market racing to keep up with the metro's growth. Encore Commercial Capital funds Austin businesses that move faster than bank committees.",
      "Working capital, equipment financing, business lines of credit, SBA loans, and commercial real estate financing — apply online in about five minutes, approvals in as soon as 2 hours.",
    ],
    industries: ["Technology & SaaS services", "Restaurants & music venues", "Construction & development", "Professional services", "Healthcare & wellness", "Retail & e-commerce"],
  },
];

export const MARKETS = [
  ...LOCATIONS.map((l) => ({
    ...l,
    label: `${l.city}, NC`,
    shortName: l.city,
    region: l.metro,
    schemaType: "City",
    schemaName: `${l.city}, North Carolina`,
  })),
  ...METROS.map((m) => ({
    ...m,
    label: `${m.city}, ${m.state}`,
    shortName: m.city,
    region: m.metro,
    schemaType: "City",
    schemaName: `${m.city}, ${m.stateName}`,
  })),
  ...STATES.map((s) => ({
    ...s,
    label: s.name,
    shortName: s.name,
    region: "Statewide coverage",
    schemaType: "State",
    schemaName: s.name,
  })),
];
